import { invalidateCanvas } from '$viewer/overlay/invalidateCanvas';
import { useDevOverlayStore } from '$viewer/store/devOverlayStore';

/** 브라우저 콘솔에서 호출하는 개발자용 명령의 공통 접두어입니다. 모든 명령은 이 접두어를 씁니다. */
export const DEV_COMMAND_PREFIX = '__dev__';

/** `window.__dev__<name>` 으로 명령을 노출합니다. 이름에 접두어를 직접 붙이지 않습니다. */
export const registerDevCommand = (
  name: string,
  command: (...argList: never[]) => unknown,
): void => {
  window[`${DEV_COMMAND_PREFIX}${name}`] = command;
};

/**
 * `__dev__vObjectOverlay()` 로 반전, `__dev__vObjectOverlay(true | false)` 로 지정합니다.
 * 캔버스가 demand 모드라 토글만으로는 다시 그려지지 않아 직접 무효화합니다.
 */
const toggleVObjectOverlay = (enabled?: boolean): boolean => {
  const next = useDevOverlayStore.getState().toggleVObjectOverlay(enabled);
  invalidateCanvas();

  return next;
};

/** 시뮬레이션 모듈을 앱 시작 번들에 싣지 않도록 호출 시점에 불러옵니다. */
const loadMotionDevCommand = () =>
  import('$simulation/motion/command/motionDevCommand');

/** 앱 시작 시 한 번 호출해 개발자용 콘솔 명령을 등록합니다. */
export const registerDevCommandList = (): void => {
  registerDevCommand('vObjectOverlay', toggleVObjectOverlay);
  registerDevCommand('motionAddTrack', async () =>
    (await loadMotionDevCommand()).addDevMotionTrack(),
  );
  registerDevCommand('motionAddFlow', async () =>
    (await loadMotionDevCommand()).addDevMotionFlow(),
  );
  registerDevCommand('motionPause', async () =>
    (await loadMotionDevCommand()).pauseDevMotion(),
  );
  registerDevCommand('motionPlay', async () =>
    (await loadMotionDevCommand()).playDevMotion(),
  );
  registerDevCommand('motionSetTime', async (sec: number) =>
    (await loadMotionDevCommand()).setDevMotionTime(sec),
  );
  registerDevCommand(
    'motionSwitchScenario',
    async (idOrIndex: string | number) =>
      (await loadMotionDevCommand()).switchDevMotionScenario(idOrIndex),
  );
  registerDevCommand('lidarDepthRenderCount', async () =>
    (await loadMotionDevCommand()).getDevLidarDepthRenderCount(),
  );
};
